/**
 * The looks the hiring screens share with the rest of the platform, kept in one place so
 * two controls meant to look alike cannot drift apart.
 *
 * HOUSE_TABS is the tab strip of the master pages, class for class as StoreMasterPage (and
 * MasterTabStrip) draws it: a light tray, the open tab a white pill in the primary colour,
 * a 16px icon before each name and any count in brackets after it. The Hiring dashboard's
 * status filter, its "Waiting | Past" switch and an opening's Details / Team / Candidates
 * tabs are drawn with it (the product owner, 15 Oct 2026: "one theme").
 *
 * HIRING_BUTTONS are the dashboard's two buttons beside the title: the filled one (Raise
 * hiring, Ask for hiring) and the outlined one (Raise in Manage Budgets; "Link an opening"
 * too until 16 Oct 2026, when it left the dashboard).
 */

export const HOUSE_TABS = {
  tray: 'flex w-fit flex-wrap items-center gap-1 rounded-lg border border-gray-100 bg-gray-50 p-1',
  tab: 'flex items-center gap-1.5 rounded-md px-4 py-1.5 text-sm font-semibold transition-colors',
  on: 'bg-white text-primary-600 shadow-sm',
  off: 'text-gray-600 hover:text-gray-800',
  icon: 'h-4 w-4',
} as const;

/** One tab of the strip, open or not. */
export const houseTabClass = (on: boolean): string => `${HOUSE_TABS.tab} ${on ? HOUSE_TABS.on : HOUSE_TABS.off}`;

/** A tab's name with its count in brackets ("Filled (1)"); the name alone while the count is not known. */
export const withCount = (label: string, count: number | null | undefined): string =>
  (typeof count === 'number' && Number.isFinite(count) ? `${label} (${count})` : label);

export const HIRING_BUTTONS = {
  primary: 'inline-flex h-10 items-center rounded-xl bg-primary-600 px-4 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primary-700',
  secondary: 'inline-flex h-10 items-center rounded-xl border border-gray-200 bg-white px-4 text-sm font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50',
} as const;
